// extracted by mini-css-extract-plugin
module.exports = {"textmain":"TxMessage_textmain__1-Cck"};